export default __webpack_public_path__ + "38eb90c2d1585387b9d4c3ba58ec1d4c.jpg";